import { axiosInstance } from "../../axios";
const school_Reporting_Service = `${process.env.REACT_APP_SCHOOL_REPORTING_BASE}`;


export const getRazorPayConfig = (params) => {
    console.log('====================================');
    console.log("This is the params",params);
    console.log('====================================');
  return axiosInstance.get(`${school_Reporting_Service}/razorpay/getConfig`, { params });
};

export const updateRazorPayConfig = (payload) => {
  return axiosInstance.put(`${school_Reporting_Service}/razorpay/updateConfig`, {...payload});
}